/**
 * Guard against InvalidStateError when calling showModal() on an already open Livewire error dialog.
 * This can happen when multiple errors occur in quick succession.
 */
export function installErrorDialogShowModalGuard(): void {
    // Environment check: skip if HTMLDialogElement is not supported (e.g., SSR or old browsers)
    if (typeof HTMLDialogElement === 'undefined') {
        return
    }

    const prototype = HTMLDialogElement.prototype as {
        __weytopLivewireErrorDialogShowModalGuardInstalled?: boolean
    }
    const guardKey = '__weytopLivewireErrorDialogShowModalGuardInstalled'

    // Idempotency check: skip if guard already installed
    if (prototype[guardKey]) {
        return
    }

    const originalShowModal = HTMLDialogElement.prototype.showModal

    if (typeof originalShowModal !== 'function') {
        return
    }

    // Mark the prototype to prevent multiple installations
    Object.defineProperty(HTMLDialogElement.prototype, guardKey, {
        value: true,
        configurable: false,
        enumerable: false,
        writable: false,
    })

    // Monkey-patch showModal to prevent InvalidStateError on Livewire error dialog
    HTMLDialogElement.prototype.showModal = function (
        this: HTMLDialogElement,
        ...args: Parameters<HTMLDialogElement['showModal']>
    ): void {
        if (this.id === 'livewire-error' && this.open) {
            return
        }

        return originalShowModal.apply(this, args)
    }
}
